<template>
  <section class="app-rules border container">
    <h3 class="block__topic" id="rules">大赛规则</h3>

    <button
      class="app-ranking__btn app-ranking__btn-bold"
      :class="{ active: current === 'intro' }"
      @click="() => onCurrentChange('intro')"
    >
      <span>赛事简介</span>
    </button>
    <button
      class="app-ranking__btn app-ranking__btn-light"
      :class="{ active: current === 'rule' }"
      @click="() => onCurrentChange('rule')"
    >
      <span>赛事规则</span>
    </button>

    <div class="app-rules__bg">
      <Intro v-if="current === 'intro'" />

      <Rule v-else />
    </div>
  </section>
</template>

<script>
import Intro from "./intro";
import Rule from "./rule";

export default {
  name: "Rules",
  components: {
    Intro,
    Rule
  },
  data() {
    return {
      current: "intro"
    };
  },
  methods: {
    onCurrentChange(current) {
      this.current = current
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/vars.scss";
@import "../../styles/mixin.scss";

.app-rules {
  position: relative;
  margin: percentage(130px / $baseWidth) auto 0;
  border: 2px solid;
  border-image: linear-gradient(
      360deg,
      rgba(134, 76, 46, 0.26),
      rgba(134, 76, 46, 0.52),
      rgba(134, 76, 46, 0.46),
      rgba(134, 76, 46, 1),
      rgba(134, 76, 46, 0.2)
    )
    2 2;
  border-top: none;
  border-top: 0;

  &__bg {
    width: 100%;
    height: 100%;
    @include image-2x(
      "../../assets/rules-bg@1x.png",
      right center,
      no-repeat,
      contain
    );
  }

  .block__topic {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -65.0625%);
    @include image-2x(
      "../../assets/title-rules@1x.png",
      center top,
      no-repeat,
      100% auto
    );
  }
}

@include mobile {
  .app-rules {
  }
}
</style>
